import React from 'react';
import '../Css/App.css';
import { IconButton } from "@mui/material";
// import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export function Footer() {
    const getCurrentYear = () => new Date().getFullYear();

    const handleContactClick = (url: string) => {
        if(!window.confirm("Open WhatsApp to start chatting with us?")) {
            return;
        }
        window.open(url, "_blank", "noopener,noreferrer");
    };


    return (
      <footer className="about-footer">
          <div>
              Copyright © {getCurrentYear()} Smart Task Software
          </div>
          <div>
              <h2>Social</h2>
              {/*<a href="" target="_blank" rel="noopener noreferrer">*/}
              {/*    <IconButton>*/}
              {/*        <FacebookOutlinedIcon/>*/}
              {/*    </IconButton>*/}
              {/*</a>*/}
              {/*<a href="" target="_blank" rel="noopener noreferrer">*/}
              {/*    <IconButton>*/}
              {/*        <InstagramIcon/>*/}
              {/*    </IconButton>*/}
              {/*</a>*/}

              <a href="https://www.linkedin.com/company/smart-task-software/" target="_blank" rel="noopener noreferrer">
                  <IconButton>
                      <LinkedInIcon />
                  </IconButton>
              </a>
              <IconButton onClick={ () => handleContactClick("https://wa.me/40775664429")}>
                  <WhatsAppIcon/>
              </IconButton>
          </div>

      </footer>
    );
}
